import React from "react";
import "./First.css";
import { Container } from "react-bootstrap";
import lady from "../../../../Asset/Women-min.png";
import { MdTask } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const First = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="first-extra-indus-section hero-sec">
        <Container>
          <div className="row align-items-center extra-indus-row">
            <div className="col-md-6 col-xl-6">
              <div className="hero-title mb-0">
                <div className="hero-dec-text">
                  <h1 className="h1">
                    Industry-Custom Software Solutions That’ll Make Your
                    <strong> Business Shine</strong>
                  </h1>
                </div>
                <div className="hero-action-btn">
                  <p
                    className="btn btn-primary me-2"
                    onClick={() => {
                      navigate("/ContactUs");
                    }}
                  >
                    Get Ahead
                  </p>
                  <p
                    className="btn btn-primary-outline"
                    onClick={() => {
                      navigate("/portfolio");
                    }}
                  >
                    <MdTask className="img" />
                    Our Work
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-6 indus-col">
              <img src={lady} className="w-75 women_image" alt="women" />
              <div className="industries_svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="730"
                  height="730"
                  viewBox="0 0 730 730"
                  fill="none"
                  className="industries-element"
                >
                  <rect width="730" height="730"></rect>
                  <circle
                    cx="365"
                    cy="365"
                    r="216"
                    fill="url(#paint0_linear_0_1)"
                  ></circle>
                  <circle
                    cx="365"
                    cy="365"
                    r="300"
                    stroke="url(#paint1_linear_0_1)"
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeDasharray="16 16"
                  ></circle>
                  <g className="industries-circle">
                    <g className="edtech">
                      <rect
                        x="90"
                        y="511"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#BEFFEC"
                      ></rect>
                      <g
                        className="indust-inner-element"
                        clipPath="url(#clip0_0_1)"
                      >
                        <path
                          d="M194.647 560.247V612.872H115.836V560.247C115.836 557.544 118.028 555.352 120.733 555.352H189.75C192.454 555.352 194.647 557.544 194.647 560.247Z"
                          fill="white"
                        ></path>
                        <path
                          d="M115.836 605.059H194.647V612.875H115.836V605.059Z"
                          fill="#70F3CC"
                        ></path>
                        <path
                          d="M188.588 561.41V602.115H121.891V561.41H188.588Z"
                          fill="#BEFFEC"
                        ></path>
                        <path
                          d="M198.241 608.172H112.242V611.048C112.242 614.98 115.429 618.167 119.361 618.167H191.122C195.053 618.167 198.241 614.98 198.241 611.048V608.172Z"
                          fill="white"
                        ></path>
                        <path
                          d="M159.907 613.169H150.579C147.9 613.169 145.728 610.998 145.728 608.318V608.172H164.758V608.318C164.758 610.998 162.586 613.169 159.907 613.169ZM127.142 618.167H119.363C115.43 618.167 112.242 614.98 112.242 611.048V608.173H120.022V611.048C120.022 614.98 123.209 618.167 127.142 618.167Z"
                          fill="#70F3CC"
                        ></path>
                        <path
                          d="M174.368 560.293V567.604C174.368 571.969 171.76 575.934 167.726 577.609C159.743 580.927 150.734 580.927 142.751 577.609C138.717 575.934 136.109 571.969 136.109 567.604V560.293H174.368Z"
                          fill="#665E66"
                        ></path>
                        <path
                          d="M174.367 560.293V563.224L158.709 571.519C157.64 572.085 156.448 572.381 155.238 572.381C154.028 572.381 152.837 572.085 151.767 571.519L136.109 563.224V560.293H174.367Z"
                          fill="#454045"
                        ></path>
                        <path
                          d="M183.807 548.27L158.712 534.976C157.643 534.409 156.452 534.113 155.242 534.113C154.032 534.113 152.84 534.409 151.771 534.976L126.676 548.27C123.858 549.763 123.858 553.8 126.676 555.293L151.771 568.587C152.84 569.153 154.032 569.449 155.242 569.449C156.452 569.449 157.643 569.153 158.712 568.587L183.807 555.293C186.625 553.8 186.625 549.763 183.807 548.27Z"
                          fill="#665E66"
                        ></path>
                      </g>
                    </g>
                    <g className="ecommerce">
                      <rect
                        x="90"
                        y="91"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#CBE0FF"
                      ></rect>
                      <g
                        className="indust-inner-element"
                        clipPath="url(#clip1_0_1)"
                      >
                        <path
                          d="M123.008 134.769V169.086C123.008 172.138 125.494 174.612 128.56 174.612H181.455C184.522 174.612 187.008 172.138 187.008 169.086V134.769C187.008 131.749 184.548 129.301 181.514 129.301H128.502C125.467 129.301 123.008 131.749 123.008 134.769Z"
                          fill="white"
                        ></path>
                        <path
                          d="M167.92 182.147L155.011 185.139L142.102 182.147L143.87 174.611L154.463 170.648L166.152 174.611L166.724 177.05L167.92 182.147Z"
                          fill="#035CAF"
                        ></path>
                        <path
                          d="M187.008 168.297V168.961C187.008 172.081 184.521 174.611 181.454 174.611H128.56C125.493 174.611 123.008 172.081 123.008 168.961V168.297H187.008Z"
                          fill="#1770C3"
                        ></path>
                        <path
                          d="M148.172 182.147H167.916L166.72 177.051H149.368L148.172 182.147Z"
                          fill="#1770C3"
                        ></path>
                        <path
                          d="M175.526 186.344V188.134H134.492V186.344C134.492 184.027 136.339 182.148 138.617 182.148H171.401C173.679 182.148 175.526 184.027 175.526 186.344Z"
                          fill="#035CAF"
                        ></path>
                        <path
                          d="M136.627 135.691H162.769L166.1 168.298H133.297L136.627 135.691Z"
                          fill="#FF491F"
                        ></path>
                        <path
                          d="M151.956 146.23H170.127L172.442 168.295H149.641L151.956 146.23Z"
                          fill="#FFE14D"
                        ></path>
                        <path
                          d="M156.749 139.876C156.621 139.876 156.493 139.851 156.374 139.801C156.255 139.75 156.147 139.677 156.057 139.584C155.966 139.492 155.893 139.382 155.844 139.261C155.795 139.14 155.77 139.011 155.77 138.88V132.304C155.77 128.897 153.045 126.126 149.697 126.126C146.348 126.126 143.623 128.897 143.623 132.304V138.88C143.623 139.144 143.52 139.397 143.336 139.584C143.153 139.771 142.903 139.876 142.644 139.876C142.384 139.876 142.135 139.771 141.951 139.584C141.767 139.397 141.664 139.144 141.664 138.88V132.304C141.664 127.798 145.268 124.133 149.697 124.133C154.125 124.133 157.729 127.799 157.729 132.304V138.88C157.729 139.011 157.704 139.14 157.654 139.261C157.605 139.382 157.533 139.492 157.442 139.585C157.351 139.677 157.243 139.751 157.124 139.801C157.005 139.851 156.878 139.876 156.749 139.876Z"
                          fill="#3C3F4D"
                        ></path>
                        <path
                          d="M161.051 159.82C158.188 159.82 155.859 157.451 155.859 154.539V150.255C155.858 150.123 155.882 149.992 155.931 149.87C155.979 149.748 156.051 149.636 156.142 149.543C156.234 149.449 156.342 149.375 156.462 149.324C156.581 149.273 156.709 149.247 156.839 149.247C156.969 149.247 157.097 149.273 157.217 149.324C157.336 149.375 157.445 149.449 157.536 149.543C157.627 149.636 157.699 149.748 157.747 149.87C157.796 149.992 157.82 150.123 157.819 150.255V154.539C157.819 156.353 159.269 157.827 161.051 157.827C162.833 157.827 164.284 156.353 164.284 154.539V150.255C164.282 150.123 164.305 149.991 164.354 149.868C164.402 149.746 164.474 149.634 164.565 149.54C164.656 149.446 164.765 149.371 164.885 149.32C165.005 149.268 165.133 149.242 165.263 149.242C165.393 149.242 165.522 149.268 165.642 149.32C165.762 149.371 165.87 149.446 165.961 149.54C166.053 149.634 166.124 149.746 166.173 149.868C166.221 149.991 166.245 150.123 166.243 150.255V154.539C166.243 157.451 163.914 159.82 161.051 159.82Z"
                          fill="#3C3F4D"
                        ></path>
                        <path
                          d="M183.423 150.278H174.019C173.759 150.278 173.51 150.173 173.326 149.986C173.142 149.799 173.039 149.546 173.039 149.282C173.039 149.017 173.142 148.764 173.326 148.577C173.51 148.39 173.759 148.285 174.019 148.285H183.423C183.551 148.285 183.679 148.311 183.797 148.361C183.916 148.411 184.024 148.485 184.115 148.577C184.206 148.67 184.278 148.779 184.328 148.9C184.377 149.021 184.402 149.151 184.402 149.282C184.402 149.546 184.299 149.799 184.115 149.986C183.931 150.173 183.682 150.278 183.423 150.278ZM183.423 154.929H175.978C175.719 154.929 175.469 154.824 175.286 154.637C175.102 154.45 174.999 154.196 174.999 153.932C174.999 153.668 175.102 153.414 175.286 153.227C175.469 153.041 175.719 152.936 175.978 152.936H183.423C183.551 152.936 183.679 152.961 183.798 153.011C183.916 153.062 184.024 153.135 184.115 153.228C184.206 153.32 184.278 153.43 184.328 153.551C184.377 153.672 184.402 153.801 184.402 153.932C184.402 154.197 184.299 154.45 184.115 154.637C183.931 154.824 183.682 154.929 183.423 154.929Z"
                          fill="#3C3F4D"
                        ></path>
                      </g>
                    </g>
                    <g className="entertainment">
                      <rect
                        x="300"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#FFD9C3"
                      ></rect>
                      <g className="indust-inner-element">
                        <path
                          d="M365 103C385.987 103 403 85.9868 403 65C403 44.0132 385.987 27 365 27C344.013 27 327 44.0132 327 65C327 85.9868 344.013 103 365 103Z"
                          fill="#FC7021"
                        ></path>
                        <path
                          d="M357.33 81.2545L382.838 66.5271C383.106 66.3725 383.328 66.1501 383.482 65.8825C383.636 65.6149 383.718 65.3114 383.718 65.0025C383.718 64.6936 383.636 64.3901 383.482 64.1225C383.328 63.8548 383.106 63.6325 382.838 63.4778L357.33 48.7489C357.062 48.5955 356.759 48.5151 356.45 48.5156C356.141 48.5161 355.838 48.5976 355.571 48.7519C355.303 48.9062 355.081 49.1279 354.926 49.3949C354.771 49.6619 354.689 49.9649 354.688 50.2736V79.729C354.689 80.0378 354.771 80.3409 354.926 80.608C355.081 80.8751 355.303 81.0969 355.57 81.2513C355.838 81.4057 356.141 81.4872 356.45 81.4878C356.758 81.4883 357.062 81.4079 357.33 81.2545Z"
                          fill="#FFFCEE"
                        ></path>
                      </g>
                    </g>
                    <g className="security">
                      <rect
                        x="510"
                        y="91"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#B1FFDE"
                      ></rect>
                      <g
                        className="indust-inner-element"
                        clipPath="url(#clip2_0_1)"
                      >
                        <path
                          d="M605.348 169.423C603.198 175.251 599.946 180.318 595.681 184.483C590.827 189.223 584.471 192.989 576.789 195.676C576.534 195.764 576.274 195.836 576.009 195.889C575.66 195.958 575.305 195.995 574.953 196H574.884C574.509 196 574.131 195.962 573.757 195.889C573.493 195.836 573.234 195.764 572.983 195.678C565.292 192.995 558.928 189.231 554.069 184.491C549.802 180.326 546.551 175.262 544.404 169.434C540.499 158.839 540.721 147.166 540.9 137.786L540.903 137.642C540.939 136.868 540.962 136.054 540.975 135.156C541.041 130.745 544.548 127.096 548.959 126.85C558.157 126.336 565.273 123.336 571.352 117.411L571.406 117.362C572.415 116.436 573.687 115.982 574.953 116.001C576.174 116.016 577.389 116.47 578.363 117.362L578.415 117.41C584.496 123.336 591.611 126.336 600.809 126.849C605.221 127.096 608.728 130.745 608.793 135.156C608.806 136.06 608.829 136.873 608.865 137.642L608.867 137.703C609.045 147.101 609.266 158.796 605.348 169.423Z"
                          fill="#00DD80"
                        ></path>
                        <path
                          d="M594.821 155.996C594.821 166.966 585.915 175.896 574.954 175.935H574.884C563.891 175.935 554.945 166.99 554.945 155.996C554.945 145.003 563.891 136.059 574.884 136.059H574.954C585.915 136.098 594.821 145.027 594.821 155.996Z"
                          fill="white"
                        ></path>
                        <path
                          d="M583.936 153.132L574.956 162.113L573.016 164.053C572.798 164.271 572.54 164.445 572.255 164.562C571.97 164.68 571.664 164.741 571.356 164.74C571.048 164.741 570.742 164.68 570.457 164.562C570.172 164.445 569.913 164.271 569.695 164.053L565.523 159.88C564.607 158.963 564.607 157.478 565.523 156.56C566.439 155.644 567.926 155.644 568.843 156.56L571.356 159.074L580.617 149.813C581.534 148.896 583.021 148.896 583.936 149.813C584.853 150.73 584.853 152.217 583.936 153.132Z"
                          fill="#B4D2D7"
                        ></path>
                        <path
                          d="M583.933 153.132L574.953 162.113V155.473L580.614 149.813C581.53 148.896 583.017 148.896 583.933 149.813C584.849 150.73 584.849 152.217 583.933 153.132Z"
                          fill="#6FA5AA"
                        ></path>
                      </g>
                    </g>
                    <g className="fitness">
                      <rect
                        y="301"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#FFDEDC"
                      ></rect>
                      <g
                        className="indust-inner-element"
                        clipPath="url(#clip3_0_1)"
                      >
                        <path
                          d="M77.7897 329.564C76.5901 328.967 74.8702 327.953 73.5176 326.52C69.7877 322.57 60.5371 320.856 56.1442 327.268C55.8626 327.679 55.4678 327.998 55.0157 328.208C52.8247 329.223 47.4888 332.91 52.7892 342.169C54.0537 344.378 54.8729 346.229 55.376 347.779C56.3624 346.661 57.2527 345.333 57.2864 344.15C57.3214 342.929 56.9779 341.988 56.7019 341.232C56.3865 340.368 56.178 339.797 56.5951 339.229C57.1808 338.43 58.1609 338.614 58.8835 339.052C59.2921 339.3 59.5369 339.77 59.5224 340.279L59.4977 341.139C59.4896 341.439 59.6006 341.73 59.8064 341.948C60.0122 342.166 60.2961 342.293 60.5958 342.302C60.8855 342.311 61.1676 342.208 61.3834 342.014C61.5993 341.821 61.7325 341.551 61.7554 341.262C62.0806 337.164 62.6974 334.318 63.4055 333.649C63.9655 333.12 65.2692 333.285 66.9186 333.494C68.8413 333.737 71.2105 334.037 73.7778 333.484C73.7627 333.546 73.7464 333.617 73.7297 333.691L74.1166 333.156C74.1166 333.156 76.1176 332.429 77.8839 331.262C78.5163 330.844 78.4676 329.902 77.7897 329.564Z"
                          fill="#383B43"
                        ></path>
                        <path
                          d="M55.0157 328.205C52.8247 329.221 47.4888 332.908 52.7892 342.167C54.0537 344.376 54.8729 346.226 55.376 347.776C56.3624 346.659 57.2527 345.33 57.2864 344.148C57.3214 342.927 56.9779 341.986 56.7019 341.229C56.3865 340.365 56.178 339.795 56.5951 339.226C57.1808 338.427 58.1607 338.611 58.8835 339.049C59.2922 339.297 59.537 339.768 59.5224 340.276L59.4977 341.137C59.4896 341.437 59.6006 341.727 59.8064 341.945C60.0123 342.163 60.2962 342.291 60.5959 342.3C60.8857 342.308 61.1677 342.205 61.3836 342.012C61.5995 341.818 61.7326 341.549 61.7556 341.26C62.0613 337.407 62.6245 334.662 63.2792 333.79C56.4921 333.444 56.1441 327.266 56.1441 327.266C55.8627 327.676 55.4678 327.996 55.0157 328.205Z"
                          fill="#1D1D1F"
                        ></path>
                        <path
                          d="M67.2331 361.912C67.0277 361.399 66.7625 360.814 66.4865 360.192L66.4915 360.218C64.5738 357.935 61.0349 356.833 56.1732 355.319C55.9916 355.231 53.4454 354.69 51.9475 352.839C51.6478 352.469 51.2453 351.847 51.1771 351.336C47.701 354.703 39.1193 364.578 42.5669 377.268C45.1017 386.598 45.2767 401.133 45.2822 407.372C49.766 410.283 55.2005 407.356 60.6607 408.341L65.561 408.923L65.5595 408.925C66.3703 408.972 67.1869 408.997 68.0096 408.997C68.0427 408.997 68.0756 408.996 68.1087 408.996C68.5737 405.747 70.2487 394.268 71.9169 385.624C73.8796 375.454 67.2331 361.912 67.2331 361.912Z"
                          fill="#F0F0F0"
                        ></path>
                        <path
                          d="M74.5874 340.232C72.849 337.329 74.1222 333.155 74.1222 333.155C69.0871 334.408 64.6173 332.175 63.2443 333.471C62.1663 334.489 61.6809 339.218 61.522 341.203C61.4859 341.654 61.1333 342.035 60.6811 342.058C60.5585 342.064 60.4359 342.045 60.321 342.002C60.2061 341.959 60.1014 341.892 60.0135 341.807C59.9256 341.721 59.8564 341.618 59.8104 341.504C59.7643 341.39 59.7424 341.268 59.7459 341.145L59.7707 340.276C59.7872 339.699 59.5084 339.143 59.0147 338.844C58.1391 338.312 57.046 338.21 56.4046 339.084C55.4885 340.333 57.1222 341.594 57.0491 344.143C57.0043 345.709 55.3216 347.595 54.0312 348.817C54.141 348.874 54.2312 348.963 54.2903 349.072C54.3546 349.318 54.9384 351.323 57.121 352.372C59.3055 353.422 62.7917 355.461 64.2689 356.061C64.5852 356.189 64.9034 356.416 65.1864 356.697C65.0238 356.042 64.9373 355.409 64.9786 354.835C65.3023 350.334 70.3953 354.831 72.0392 353.68C74.5384 351.93 72.5987 346.153 73.9129 345.84C76.5955 345.201 76.3259 343.136 74.5874 340.232Z"
                          fill="#F9BA8F"
                        ></path>
                        <path
                          d="M59.7459 341.143L59.7707 340.274C59.7872 339.697 59.5084 339.141 59.0147 338.842C58.1391 338.31 57.046 338.208 56.4046 339.082C55.4885 340.331 57.1222 341.592 57.0491 344.141C57.0043 345.707 55.3216 347.593 54.0312 348.815C54.141 348.872 54.2312 348.961 54.2903 349.07C54.3546 349.316 54.9384 351.321 57.121 352.37C59.3055 353.42 62.7915 355.459 64.2689 356.059C64.5852 356.187 64.9034 356.414 65.1864 356.695C65.0238 356.04 64.9373 355.407 64.9786 354.833C65.1405 352.582 66.4955 352.581 68.0153 353C60.2328 349.865 60.6811 342.056 60.6811 342.056C60.5585 342.062 60.4359 342.043 60.321 342C60.2061 341.957 60.1014 341.89 60.0135 341.805C59.9257 341.719 59.8565 341.616 59.8104 341.502C59.7644 341.388 59.7424 341.266 59.7459 341.143Z"
                          fill="#FFAA7B"
                        ></path>
                        <path
                          d="M66.3068 358.302C66.1235 357.343 65.2345 356.259 64.3301 355.892C62.8594 355.295 59.395 353.268 57.1923 352.209C54.9642 351.137 54.452 349.005 54.452 349.005C54.2068 348.515 53.5578 348.403 53.1585 348.778L51.2269 350.595C51.1092 350.706 51.0269 350.849 50.9902 351.006C50.9535 351.164 50.9641 351.329 51.0206 351.48C51.0206 351.48 51.5247 354.056 55.6809 355.352C60.8456 356.962 64.5535 358.063 66.464 360.466C66.5507 360.575 66.7257 360.492 66.6997 360.356L66.3068 358.302Z"
                          fill="#161829"
                        ></path>
                        <path
                          d="M96.1138 368.855C96.0485 368.86 95.9836 368.865 95.9181 368.868C95.7229 368.878 95.5275 368.883 95.3321 368.883C93.5079 368.885 91.7063 368.478 90.0602 367.691C89.7752 368.207 89.4767 368.647 89.1713 368.952C87.5081 370.616 83.1853 373.36 81.8027 377.565C81.7254 377.8 81.4048 377.827 81.2917 377.607C80.8624 376.771 79.9357 375.236 78.2342 373.484C76.9623 377 73.4982 384.042 65.4844 387.17C67.6127 388.669 70.2851 389.95 73.5917 390.566C73.5917 390.566 79.4175 394.961 84.1638 393.59C84.4845 393.497 84.8204 393.478 85.1483 393.541C85.7291 393.653 86.7316 393.723 87.519 393.136C88.3463 392.519 88.5722 391.64 88.6316 391.133C88.6656 390.844 88.7576 390.567 88.9103 390.318C90.0957 388.391 94.9896 379.897 96.4424 368.832C96.3335 368.842 96.2237 368.849 96.1138 368.855Z"
                          fill="#FCAD6D"
                        ></path>
                        <path
                          d="M76.7335 372.066C75.5118 375.516 72.0245 382.792 63.6875 385.749C64.2754 386.268 64.9162 386.778 65.6178 387.264C73.7933 384.185 77.1789 376.929 78.3404 373.586C77.8293 373.054 77.293 372.547 76.7335 372.066Z"
                          fill="#161829"
                        ></path>
                        <path
                          d="M71.4989 368.553C70.9354 368.257 70.4988 367.767 70.283 367.168L69.7589 365.715C69.552 365.141 69.3057 364.581 68.997 364.055C67.208 361.006 63.837 358.998 60.0114 359.157C54.8483 359.372 50.6706 363.606 50.5199 368.772C50.3985 372.939 52.848 376.549 56.3999 378.133C57.6988 378.712 58.798 379.656 59.5488 380.864C60.4068 382.244 61.7957 384.12 63.829 385.88C72.1691 382.898 75.6392 375.59 76.8433 372.167C75.4578 370.959 73.7053 369.709 71.4989 368.553Z"
                          fill="white"
                        ></path>
                        <path
                          d="M106.018 358.006C106.624 352.095 102.323 346.812 96.4119 346.206C90.5008 345.601 85.2179 349.901 84.6122 355.813C84.0066 361.724 88.3075 367.007 94.2187 367.612C100.13 368.218 105.413 363.917 106.018 358.006Z"
                          fill="#4B3E3E"
                        ></path>
                        <path
                          d="M95.3334 369.221C88.5629 369.221 83.0547 363.713 83.0547 356.943C83.0547 350.172 88.5629 344.664 95.3334 344.664C102.104 344.664 107.612 350.172 107.612 356.943C107.612 363.713 102.104 369.221 95.3334 369.221ZM95.3334 347.703C90.2389 347.703 86.0939 351.848 86.0939 356.943C86.0939 362.037 90.2387 366.182 95.3334 366.182C100.428 366.182 104.573 362.037 104.573 356.943C104.573 351.848 100.428 347.703 95.3334 347.703Z"
                          fill="#322E2E"
                        ></path>
                        <path
                          d="M95.0416 360.877C97.2453 361.031 99.1568 359.369 99.3109 357.165C99.465 354.962 97.8034 353.05 95.5996 352.896C93.3959 352.742 91.4845 354.404 91.3303 356.607C91.1762 358.811 92.8378 360.723 95.0416 360.877Z"
                          fill="white"
                        ></path>
                      </g>
                    </g>
                    <g className="fintech">
                      <rect
                        x="600"
                        y="301"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#F9FFBB"
                      ></rect>
                      <g className="indust-inner-element">
                        <path
                          d="M636.008 371.026C658.294 371.597 676.008 353.312 676.008 331.598H675.436C672.579 331.598 670.293 333.884 669.722 336.741C668.579 344.741 664.579 352.169 658.865 357.312C654.294 361.883 648.008 364.74 641.151 365.884C640.475 365.881 639.805 366.012 639.179 366.269C638.554 366.526 637.986 366.905 637.508 367.383C637.03 367.861 636.651 368.429 636.394 369.054C636.136 369.679 636.005 370.349 636.008 371.026Z"
                          fill="#CEDD25"
                        ></path>
                        <path
                          d="M653.196 349.302C652.625 349.302 652.054 349.302 651.482 348.73C650.339 347.588 650.339 345.873 651.482 344.73C654.911 341.302 656.625 336.159 656.625 331.588C656.625 329.873 657.768 328.73 659.482 328.73C661.196 328.73 662.339 329.873 662.339 331.588C662.339 337.873 660.053 344.159 656.053 348.73C654.91 349.302 653.767 349.302 653.196 349.302Z"
                          fill="#E2F139"
                        ></path>
                        <path
                          d="M664.602 405.875C686.693 405.875 704.602 387.966 704.602 365.875C704.602 343.784 686.693 325.875 664.602 325.875C642.51 325.875 624.602 343.784 624.602 365.875C624.602 387.966 642.51 405.875 664.602 405.875Z"
                          fill="#CEDD25"
                        ></path>
                        <path
                          d="M664.602 325.875C642.316 325.875 624.602 343.589 624.602 365.875C624.602 388.161 642.316 405.875 664.602 405.875C686.887 405.875 704.602 388.161 704.602 365.875C704.602 343.589 686.887 325.875 664.602 325.875ZM664.602 394.446C648.602 394.446 636.03 381.875 636.03 365.875C636.03 349.875 648.602 337.304 664.602 337.304C680.602 337.304 693.173 349.875 693.173 365.875C693.173 381.875 680.602 394.446 664.602 394.446Z"
                          fill="#E2F139"
                        ></path>
                        <path
                          d="M666.523 347.182V349.771C668.234 349.947 669.696 350.299 670.911 350.826C672.142 351.354 673.213 352.153 674.124 353.224C674.843 354.039 675.395 354.879 675.779 355.742C676.178 356.605 676.378 357.396 676.378 358.116C676.378 358.915 676.082 359.61 675.491 360.202C674.915 360.777 674.212 361.065 673.381 361.065C671.814 361.065 670.799 360.218 670.336 358.523C669.808 356.525 668.537 355.198 666.523 354.543V364.518C668.505 365.061 670.08 365.557 671.247 366.004C672.43 366.452 673.485 367.099 674.412 367.947C675.403 368.826 676.162 369.881 676.69 371.112C677.233 372.327 677.505 373.661 677.505 375.116C677.505 376.938 677.073 378.649 676.21 380.247C675.363 381.83 674.108 383.125 672.446 384.132C670.783 385.139 668.809 385.738 666.523 385.93V388.463C666.523 389.406 666.427 390.094 666.235 390.525C666.06 390.957 665.66 391.173 665.036 391.173C664.461 391.173 664.053 390.997 663.814 390.645C663.59 390.293 663.478 389.75 663.478 389.015V385.978C661.608 385.77 659.969 385.331 658.562 384.659C657.172 383.988 656.005 383.157 655.062 382.166C654.134 381.158 653.447 380.119 653 379.048C652.552 377.961 652.328 376.898 652.328 375.859C652.328 375.092 652.624 374.405 653.215 373.797C653.823 373.174 654.574 372.862 655.469 372.862C656.189 372.862 656.796 373.03 657.292 373.366C657.787 373.701 658.131 374.173 658.323 374.78C658.754 376.091 659.13 377.098 659.45 377.802C659.769 378.489 660.249 379.12 660.888 379.696C661.544 380.271 662.407 380.711 663.478 381.015V369.865C661.336 369.273 659.545 368.618 658.107 367.899C656.668 367.163 655.501 366.124 654.606 364.781C653.711 363.439 653.263 361.712 653.263 359.602C653.263 356.853 654.134 354.599 655.877 352.84C657.635 351.082 660.169 350.059 663.478 349.771V347.23C663.478 345.887 663.981 345.215 664.988 345.215C666.012 345.215 666.523 345.871 666.523 347.182ZM663.478 363.631V354.447C662.135 354.847 661.088 355.374 660.337 356.03C659.585 356.685 659.21 357.676 659.21 359.003C659.21 360.266 659.561 361.225 660.265 361.88C660.968 362.52 662.039 363.103 663.478 363.631ZM666.523 370.752V381.254C668.138 380.935 669.384 380.287 670.264 379.312C671.143 378.337 671.582 377.202 671.582 375.907C671.582 374.517 671.151 373.446 670.288 372.694C669.44 371.927 668.186 371.28 666.523 370.752Z"
                          fill="#BAC911"
                        ></path>
                        <path
                          d="M662.736 347.565C662.736 346.209 663.835 345.109 665.191 345.109C666.547 345.109 667.647 346.209 667.647 347.565V388.814C667.647 390.171 666.547 391.27 665.191 391.27C663.835 391.27 662.736 390.171 662.736 388.814V347.565Z"
                          fill="#BAC911"
                        ></path>
                      </g>
                    </g>
                    <g className="logistics">
                      <rect
                        x="510"
                        y="511"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#E0E0FF"
                      ></rect>
                      <g
                        className="indust-inner-element"
                        clipPath="url(#clip4_0_1)"
                      >
                        <path
                          d="M555.508 561.266C555.508 559.955 554.444 558.891 553.133 558.891H538.883C537.572 558.891 536.508 559.955 536.508 561.266C536.508 562.577 537.572 563.641 538.883 563.641H553.133C554.444 563.641 555.508 562.577 555.508 561.266ZM553.133 568.391H543.633C542.322 568.391 541.258 569.455 541.258 570.766C541.258 572.077 542.322 573.141 543.633 573.141H553.133C554.444 573.141 555.508 572.077 555.508 570.766C555.508 569.455 554.444 568.391 553.133 568.391ZM553.133 577.891H548.383C547.072 577.891 546.008 578.955 546.008 580.266C546.008 581.577 547.072 582.641 548.383 582.641H553.133C554.444 582.641 555.508 581.577 555.508 580.266C555.508 578.955 554.444 577.891 553.133 577.891Z"
                          fill="var(--purple-color)"
                        ></path>
                        <path
                          d="M612.171 576.67L605.046 564.795C604.835 564.442 604.536 564.151 604.179 563.948C603.822 563.746 603.418 563.64 603.008 563.641H586.383C585.072 563.641 584.008 564.705 584.008 566.016V589.766C584.008 591.077 585.072 592.141 586.383 592.141H610.133C611.444 592.141 612.508 591.077 612.508 589.766V577.891C612.508 577.458 612.394 577.036 612.171 576.67Z"
                          fill="#2C2E94"
                        ></path>
                        <path
                          d="M593.508 568.391H601.664L607.364 577.891H593.508V568.391Z"
                          fill="#FAFAFA"
                        ></path>
                        <path
                          d="M586.383 554.141H553.133C551.822 554.141 550.758 555.205 550.758 556.516V589.766C550.758 591.077 551.822 592.141 553.133 592.141H588.758V556.516C588.758 555.205 587.694 554.141 586.383 554.141Z"
                          fill="var(--purple-color)"
                        ></path>
                        <path
                          d="M598.008 598C594.975 598 592.508 595.532 592.508 592.5C592.508 589.468 594.975 587 598.008 587C601.04 587 603.508 589.468 603.508 592.5C603.508 595.532 601.04 598 598.008 598Z"
                          fill="#6768ED"
                        ></path>
                        <path
                          d="M588.758 592.141H553.133C551.822 592.141 550.758 591.077 550.758 589.766V582.641H588.758V592.141Z"
                          fill="#2C2E94"
                        ></path>
                        <path
                          d="M565.008 598C561.975 598 559.508 595.532 559.508 592.5C559.508 589.468 561.975 587 565.008 587C568.04 587 570.508 589.468 570.508 592.5C570.508 595.532 568.04 598 565.008 598Z"
                          fill="#6768ED"
                        ></path>
                      </g>
                    </g>
                    <g className="tour-and-travelling">
                      <rect
                        x="300"
                        y="600"
                        width="130"
                        height="130"
                        rx="65"
                        fill="#FFEFC7"
                      ></rect>
                      <g
                        className="indust-inner-element"
                        clipPath="url(#clip5_0_1)"
                      >
                        <mask
                          id="mask0_0_1"
                          maskUnits="userSpaceOnUse"
                          x="328"
                          y="626"
                          width="78"
                          height="78"
                        >
                          <path
                            d="M328 626H406V704H328V626Z"
                            fill="white"
                          ></path>
                        </mask>
                        <g mask="url(#mask0_0_1)">
                          <path
                            d="M329 680.5C329 673.049 344.011 667 362.5 667C380.989 667 396 673.049 396 680.5C396 687.951 380.989 694 362.5 694C344.011 694 329 687.951 329 680.5Z"
                            fill="#59FE55"
                          ></path>
                          <path
                            d="M396.985 679.377C395.522 692.498 380.618 704 362.5 704C344.382 704 329.478 692.498 328.015 679.377C327.92 678.523 328.286 678.37 328.832 679.038C329.353 679.674 331.903 680.886 334.793 680.886C337.667 680.886 340.206 679.686 341.519 678.1C341.63 677.967 341.81 677.967 341.921 678.1C343.233 679.686 345.772 680.886 348.646 680.886C351.521 680.886 354.06 679.686 355.372 678.1C355.483 677.967 355.663 677.967 355.774 678.1C357.086 679.686 359.626 680.886 362.5 680.886C365.374 680.886 367.914 679.686 369.226 678.1C369.337 677.967 369.517 677.967 369.628 678.1C370.94 679.686 373.479 680.886 376.354 680.886C379.228 680.886 381.767 679.686 383.079 678.1C383.19 677.967 383.37 677.967 383.481 678.1C384.793 679.686 387.333 680.886 390.207 680.886C393.097 680.886 395.647 679.674 396.168 679.038C396.714 678.37 397.08 678.523 396.985 679.377Z"
                            fill="#36B4EF"
                          ></path>
                          <path
                            d="M360.967 634.047C362.224 636.527 363.771 639.14 365.405 641.52L366.775 641.091L366.222 642.68C367.752 644.797 369.328 646.666 370.792 648C372.74 643.467 372.332 638.923 369.57 634.367C366.87 629.914 363.014 627.125 358 626C358.215 627.695 359.071 630.085 360.311 632.707L362.023 632.888L360.967 634.047Z"
                            fill="url(#paint2_linear_0_1)"
                          ></path>
                          <path
                            d="M383.251 639.31C381.165 641.037 378.765 642.772 376.372 644.271L375.281 643.382L375.187 644.993C372.989 646.297 370.843 647.364 369.002 648C368.932 643.269 371.019 639.402 375.264 636.399C379.413 633.464 383.992 632.43 389 633.296C388.164 634.715 386.48 636.511 384.356 638.369L382.722 637.894L383.251 639.31Z"
                            fill="url(#paint3_linear_0_1)"
                          ></path>
                          <path
                            d="M369.477 648C361.03 653.831 355.397 663.169 353.053 673.789C352.783 675.009 353.574 676 354.818 676H359.479C360.723 676 361.675 674.987 361.604 673.739C361.053 664.074 363.409 654.839 370 648.592L369.477 648Z"
                            fill="#59FE55"
                          ></path>
                          <path
                            d="M386.88 647.14C384.172 647.568 381.187 647.859 378.331 647.96L377.851 646.737L376.928 647.995C374.343 648.029 371.927 647.897 370 647.558C372.41 643.703 376.237 641.546 381.482 641.087C386.608 640.638 391.114 641.925 395 644.946C393.535 645.705 391.139 646.375 388.329 646.892L387.162 645.751L386.88 647.14Z"
                            fill="url(#paint4_linear_0_1)"
                          ></path>
                          <path
                            d="M379.53 654.925C377.84 654.038 376.058 652.94 374.433 651.777L374.711 650.779L373.641 651.196C372.194 650.106 370.916 648.981 370 647.932C373.048 646.475 376.126 646.726 379.233 648.686C382.271 650.602 384.193 653.373 385 657C383.852 656.861 382.227 656.263 380.442 655.389L380.303 654.148L379.53 654.925Z"
                            fill="url(#paint5_linear_0_1)"
                          ></path>
                          <path
                            d="M356.073 642.646C358.194 643.845 360.589 644.996 362.935 645.93L363.72 644.921L364.093 646.375C366.234 647.167 368.288 647.753 370 648C369.205 643.665 366.695 640.51 362.471 638.537C358.342 636.609 354.186 636.495 350 638.196C350.981 639.34 352.767 640.675 354.945 641.987L356.275 641.257L356.073 642.646Z"
                            fill="url(#paint6_linear_0_1)"
                          ></path>
                          <path
                            d="M358.854 651.639C360.731 651.354 362.756 650.914 364.649 650.372L364.662 649.431L365.575 650.096C367.275 649.567 368.823 648.959 370 648.314C367.473 646.186 364.437 645.526 360.893 646.333C357.428 647.122 354.797 648.969 353 651.872C354.145 652.079 355.879 652.026 357.845 651.779L358.327 650.747L358.854 651.639Z"
                            fill="url(#paint7_linear_0_1)"
                          ></path>
                          <path
                            d="M333.257 646.559C334.328 642.562 338.443 640.186 342.441 641.257C346.438 642.328 348.814 646.443 347.743 650.441C346.672 654.438 342.557 656.814 338.559 655.743C334.562 654.672 332.186 650.557 333.257 646.559Z"
                            fill="#FFB800"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_0_1"
                      x1="581"
                      y1="363.326"
                      x2="149"
                      y2="363.326"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="var(--primary-gradiant)"></stop>
                      <stop offset="1" stopColor="var(--primary-color)"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_0_1"
                      x1="665"
                      y1="362.675"
                      x2="65"
                      y2="362.675"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="var(--primary-gradiant)"></stop>
                      <stop offset="1" stopColor="var(--primary-color)"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_0_1"
                      x1="358"
                      y1="626"
                      x2="372"
                      y2="626"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.022" stopColor="#32BF61"></stop>
                      <stop offset="1" stopColor="#239B4B"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_0_1"
                      x1="369"
                      y1="633"
                      x2="389"
                      y2="633"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.022" stopColor="#32BF61"></stop>
                      <stop offset="1" stopColor="#239B4B"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_0_1"
                      x1="370"
                      y1="641"
                      x2="395"
                      y2="641"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.022" stopColor="#32BF61"></stop>
                      <stop offset="1" stopColor="#239B4B"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear_0_1"
                      x1="370"
                      y1="647"
                      x2="385"
                      y2="647"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.022" stopColor="#32BF61"></stop>
                      <stop offset="1" stopColor="#239B4B"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear_0_1"
                      x1="350"
                      y1="637"
                      x2="370"
                      y2="637"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.022" stopColor="#32BF61"></stop>
                      <stop offset="1" stopColor="#239B4B"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint7_linear_0_1"
                      x1="353"
                      y1="646"
                      x2="370"
                      y2="646"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.022" stopColor="#32BF61"></stop>
                      <stop offset="1" stopColor="#239B4B"></stop>
                    </linearGradient>
                    <clipPath id="clip0_0_1">
                      <rect
                        width="86"
                        height="86"
                        fill="white"
                        transform="translate(112.242 533.141)"
                      ></rect>
                    </clipPath>
                    <clipPath id="clip1_0_1">
                      <rect
                        width="64"
                        height="64"
                        fill="white"
                        transform="translate(123.008 124.133)"
                      ></rect>
                    </clipPath>
                    <clipPath id="clip2_0_1">
                      <rect
                        width="80"
                        height="80"
                        fill="white"
                        transform="translate(535 116)"
                      ></rect>
                    </clipPath>
                    <clipPath id="clip3_0_1">
                      <rect
                        width="86"
                        height="86"
                        fill="white"
                        transform="translate(25.0078 322.996)"
                      ></rect>
                    </clipPath>
                    <clipPath id="clip4_0_1">
                      <rect
                        width="76"
                        height="76"
                        fill="white"
                        transform="translate(536.508 538.141)"
                      ></rect>
                    </clipPath>
                    <clipPath id="clip5_0_1">
                      <rect
                        width="78"
                        height="78"
                        fill="white"
                        transform="translate(328 626)"
                      ></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
